export default {
	0: "Speaker",
	1: "Coordinator",
	2: "Moderator",
	3: "TechnicalSupportTeam",
	4: "SupportTeam"
};
